import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { DurationPipe } from '../../pipes/duration.pipe';

@Component({
    selector: 'app-duration-timer',
    template: `<span>{{ durationInMs | duration:true }}</span>`,
    standalone: true,
    imports: [DurationPipe]
})
export class DurationTimerComponent implements OnInit, OnDestroy {
  @Input() startTime!: Date | number;

  durationInMs = 0;
  private timerSubscription!: Subscription;

  ngOnInit(): void {
    this.updateDuration();

    this.timerSubscription = interval(1000).subscribe(() => {
      this.updateDuration();
    });
  }

  updateDuration(): void {
    const start = this.startTime instanceof Date ? this.startTime : new Date(this.startTime);
    this.durationInMs = Date.now() - start.getTime();
  }

  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();
  }
}
